import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_101: FaireProductEntity = {
  token: "catalog_prod_prod-101",
  type: "product",
  name: "Gift Box",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1602874801007-bd458bb1b8b6?w=400&h=400&fit=crop",
  priceDollars: 52.61,
  msrpDollars: 131.53,
  sku: "CA0101",
  caseSize: 1,
  material: "Metal",
  collectionToken: "col_camp",
  categoryTokens: ["catalog_cat_bath"],
  isNew: true,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: false,
  stockLevel: 383,
  description: "Beautiful Camp! piece perfect for any home.",
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
